import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import i18n from "@/plugins/i18n";
import NiceData from "@/components/common/NiceData";
import NiceDataTable from "@/components/common/NiceDataTable";
import ConfirmDeleteDialog from "@/components/common/ConfirmDialogDelete";
import VueJsonPretty from "vue-json-pretty";

// Mixins
import RestrictHelper from "@/_helpers/RestrictHelper";

Vue.config.productionTip = false;
Vue.component("nice-data", NiceData);
Vue.component("nice-data-table", NiceDataTable);
Vue.component("vue-json-pretty", VueJsonPretty);
Vue.component("confirm-delete-dialog", ConfirmDeleteDialog);

Vue.mixin(RestrictHelper);

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount("#app");
